/* Avalon Main Product: variant pickers, quantity, subscription cards and the gallery for sections/avalon-main-product.liquid.
   The product form itself is Shopify's own (it posts to /cart/add); this script only keeps the page in step with the
   chosen variant: hidden variant id, prices, availability, the URL (?variant=), the matching photo and subscription prices. */
(function () {
  function money(cents, cur) {
    try { return new Intl.NumberFormat(document.documentElement.lang || undefined, { style: 'currency', currency: cur }).format(cents / 100); }
    catch (e) { return '$' + (cents / 100).toFixed(2); }
  }
  function $all(root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }

  function init(root) {
    if (root.avalonMP) return;
    root.avalonMP = true;
    var jsonEl = root.querySelector('[data-mp-json]');
    if (!jsonEl) return;
    var data;
    try { data = JSON.parse(jsonEl.textContent); } catch (e) { return; }
    var cur = root.getAttribute('data-currency') || 'USD';
    var selects = $all(root, '[data-mp-option]');
    var idInput = root.querySelector('[data-mp-id]');
    var qty = root.querySelector('[data-mp-qty]');
    var atc = root.querySelector('[data-mp-atc]');
    var planInput = root.querySelector('[data-mp-selling-plan]');
    var planSelect = root.querySelector('[data-mp-plan]');
    var radios = $all(root, '[data-mp-purchase]');
    var strings = { add: atc ? atc.getAttribute('data-label-add') : '', sold: atc ? atc.getAttribute('data-label-sold') : '', na: atc ? atc.getAttribute('data-label-na') : '' };
    var subTitle = root.querySelector('[data-mp-sub-title]');
    var bundleApi = null; // set below when the page has a bundle block

    function current() {
      if (!selects.length) return data.variants[0];
      var vals = selects.map(function (s) { return s.value; });
      for (var i = 0; i < data.variants.length; i++) {
        var v = data.variants[i], ok = true;
        for (var j = 0; j < vals.length; j++) if (v.options[j] !== vals[j]) { ok = false; break; }
        if (ok) return v;
      }
      return null;
    }
    function allocFor(v, planId) {
      if (!v || !v.selling_plan_allocations) return null;
      for (var i = 0; i < v.selling_plan_allocations.length; i++) if (String(v.selling_plan_allocations[i].selling_plan_id) === String(planId)) return v.selling_plan_allocations[i];
      return null;
    }
    function purchaseMode() {
      var r = radios.filter(function (x) { return x.checked; })[0];
      return r ? r.value : 'one';
    }
    function setText(sel, text) { $all(root, sel).forEach(function (el) { el.textContent = text; }); }

    // Photos other than the one on show are fetched later (idle, hover, or when chosen), so a phone is not loading 7 big photos at once
    function loadSlide(img) {
      if (!img || !img.hasAttribute('data-src')) return;
      if (img.hasAttribute('data-srcset')) { img.srcset = img.getAttribute('data-srcset'); img.removeAttribute('data-srcset'); }
      img.src = img.getAttribute('data-src');
      img.removeAttribute('data-src');
    }
    function loadRemainingSlides() {
      var pending = $all(root, '[data-mp-slide][data-src]'), i = 0;
      (function next() {
        if (i >= pending.length) return;
        loadSlide(pending[i++]);
        setTimeout(next, 700);
      })();
    }
    if (document.readyState === 'complete') setTimeout(loadRemainingSlides, 1500);
    else window.addEventListener('load', function () { setTimeout(loadRemainingSlides, 1500); });

    function activateSlide(mediaId) {
      var slides = $all(root, '[data-mp-slide]'), thumbs = $all(root, '[data-mp-thumb]');
      var hit = -1;
      slides.forEach(function (s, i) { if (String(s.getAttribute('data-media-id')) === String(mediaId)) hit = i; });
      if (hit < 0) return;
      loadSlide(slides[hit]); loadSlide(slides[(hit + 1) % slides.length]);
      slides.forEach(function (s, i) { s.classList.toggle('is-active', i === hit); s.setAttribute('aria-hidden', i === hit ? 'false' : 'true'); });
      thumbs.forEach(function (t, i) { t.setAttribute('aria-current', i === hit ? 'true' : 'false'); });
      root.setAttribute('data-mp-active', hit);
      moveRing(true);
    }
    // the orange frame slides to the active thumbnail; the strip scrolls only sideways (never the page)
    function moveRing(scroll) {
      var ring = root.querySelector('[data-mp-ring]'), strip = ring && ring.parentNode;
      var on = root.querySelector('[data-mp-thumb][aria-current="true"]');
      if (!ring || !on) return;
      ring.style.left = on.offsetLeft + 'px';
      ring.style.top = on.offsetTop + 'px';
      ring.style.width = on.offsetWidth + 'px';
      ring.style.height = on.offsetHeight + 'px';
      ring.classList.add('is-ready');
      if (scroll && strip) {
        var left = on.offsetLeft - (strip.clientWidth - on.offsetWidth) / 2;
        try { strip.scrollTo({ left: Math.max(0, left), behavior: 'smooth' }); } catch (e) { strip.scrollLeft = Math.max(0, left); }
      }
    }
    function stepSlide(dir) {
      var slides = $all(root, '[data-mp-slide]');
      if (!slides.length) return;
      var i = parseInt(root.getAttribute('data-mp-active') || '0', 10) + dir;
      i = (i + slides.length) % slides.length;
      activateSlide(slides[i].getAttribute('data-media-id'));
    }

    function update(fromUser) {
      var v = current();
      if (!v) {
        if (idInput) idInput.value = '';
        if (atc) { atc.disabled = true; atc.textContent = strings.na; }
        return;
      }
      if (idInput) idInput.value = v.id;
      setText('[data-mp-price]', money(v.price, cur));
      $all(root, '[data-mp-compare]').forEach(function (el) {
        if (v.compare_at_price && v.compare_at_price > v.price) { el.textContent = money(v.compare_at_price, cur); el.hidden = false; } else { el.hidden = true; }
      });
      // subscription prices for this variant
      var planId = planSelect ? planSelect.value : (planInput ? planInput.getAttribute('data-plan') : '');
      var alloc = allocFor(v, planId);
      var subCard = root.querySelector('[data-mp-sub-card]');
      if (subCard) {
        subCard.hidden = !alloc && !!planId && !planSelect;
        if (alloc) {
          var pct = Math.round(100 * (v.price - alloc.price) / v.price);
          setText('[data-mp-sub-price]', money(alloc.price, cur));
          setText('[data-mp-sub-compare]', money(v.price, cur));
          if (subTitle) subTitle.textContent = (subTitle.getAttribute('data-template') || '').replace('{discount}', pct > 0 ? String(pct) : '');
        } else if (subCard.hasAttribute('data-preview-pct')) {
          // Theme Editor preview only: the product has no selling plan yet, so show an example saving
          var pp = parseFloat(subCard.getAttribute('data-preview-pct')) || 0;
          setText('[data-mp-sub-price]', money(Math.round(v.price * (100 - pp) / 100), cur));
          setText('[data-mp-sub-compare]', money(v.price, cur));
        }
      }
      var mode = purchaseMode();
      if (planInput) {
        if (mode === 'sub' && planId) { planInput.disabled = false; planInput.value = planId; } else { planInput.disabled = true; }
      }
      if (v.featured_media && v.featured_media.id) activateSlide(v.featured_media.id);
      if (atc) {
        if (v.available) { atc.disabled = false; atc.textContent = strings.add; } else { atc.disabled = true; atc.textContent = strings.sold; }
        if (mode === 'bundle') { if (bundleApi) bundleApi.syncButton(); else atc.disabled = true; }
      }
      if (fromUser && window.history && history.replaceState) {
        try { var u = new URL(window.location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u.toString()); } catch (e) {}
      }
      root.setAttribute('data-mp-variant', v.id);
    }

    // Description: collapse to a few lines with a smooth Read more / Read less
    $all(root, '[data-mp-desc]').forEach(function (box) {
      var body = box.querySelector('[data-mp-desc-body]'), btn = box.querySelector('[data-mp-desc-toggle]');
      if (!body || !btn) return;
      var lines = parseInt(box.getAttribute('data-lines'), 10) || 4;
      var open = false;
      var extra = parseInt(box.getAttribute('data-extra'), 10);
      if (isNaN(extra)) extra = 3;
      function lineH() { var lh = parseFloat(window.getComputedStyle(body).lineHeight); return lh || 21; }
      function collapsedH() { return Math.round(lineH() * lines); }
      function setup() {
        var ch = collapsedH();
        box.classList.add('is-ready');
        if (body.scrollHeight <= ch + extra * lineH() + 6) { box.classList.add('is-short'); body.style.maxHeight = ''; return; }
        box.classList.remove('is-short');
        body.style.maxHeight = open ? body.scrollHeight + 'px' : ch + 'px';
      }
      btn.addEventListener('click', function () {
        open = !open;
        box.classList.toggle('is-open', open);
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        btn.textContent = open ? btn.getAttribute('data-less') : btn.getAttribute('data-more');
        body.style.maxHeight = (open ? body.scrollHeight : collapsedH()) + 'px';
      });
      setup();
      window.addEventListener('resize', setup);
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(setup);
    });

    // Line / Flavor dropdowns: each option is another product, so choosing one opens that product
    $all(root, '[data-mp-nav]').forEach(function (n) { n.addEventListener('change', function () { if (n.value) window.location.href = n.value; }); });

    selects.forEach(function (s) { s.addEventListener('change', function () { update(true); }); });
    radios.forEach(function (r) { r.addEventListener('change', function () { update(false); root.querySelectorAll('[data-mp-card]').forEach(function (c) { c.classList.toggle('is-selected', c.querySelector('[data-mp-purchase]').checked); }); }); });
    if (planSelect) planSelect.addEventListener('change', function () { update(false); });

    // Bundle builder: pick a pack size, choose products for the slots, add everything to the cart in one go
    (function () {
      var bundleEl = root.querySelector('[data-mp-bundle]');
      if (!bundleEl) return;
      var tiles = $all(bundleEl, '[data-mp-tile]');
      var slotsEl = bundleEl.querySelector('[data-mp-slots]');
      var slotsLabel = bundleEl.querySelector('[data-mp-slots-label]');
      var slotTpl = bundleEl.querySelector('template[data-mp-slot-tpl]');
      var picker = bundleEl.querySelector('[data-mp-picker]');
      var listEl = bundleEl.querySelector('[data-mp-picker-list]');
      var summary = bundleEl.querySelector('[data-mp-summary]');
      var sumOld = bundleEl.querySelector('[data-mp-sum-old]'), sumNew = bundleEl.querySelector('[data-mp-sum-new]'), sumSave = bundleEl.querySelector('[data-mp-sum-save]');
      var msg = bundleEl.querySelector('[data-mp-bundle-msg]');
      var products = [];
      try { products = JSON.parse(bundleEl.querySelector('[data-mp-bundle-json]').textContent) || []; } catch (e) { products = []; }
      var picked = []; // one entry (product id) per unit in the pack
      var sending = false;
      var minusSvg = '<svg viewBox="0 0 14 14" fill="none" aria-hidden="true"><path d="M1.7 7h10.6" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>';
      var plusSvg = '<svg viewBox="0 0 14 14" fill="none" aria-hidden="true"><path d="M7 1.7v10.6M1.7 7h10.6" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>';
      var xSvg = '<svg viewBox="0 0 12 12" fill="none" aria-hidden="true"><path d="M2.5 2.5l7 7M9.5 2.5l-7 7" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>';

      function activeTile() { return tiles.filter(function (x) { return x.getAttribute('aria-pressed') === 'true'; })[0] || tiles[0]; }
      function size() { var a = activeTile(); return a ? (parseInt(a.getAttribute('data-count'), 10) || 0) : 0; }
      function pct() { var a = activeTile(); return a ? (parseFloat(a.getAttribute('data-pct')) || 0) : 0; }
      function byId(id) { for (var i = 0; i < products.length; i++) if (products[i].id === id) return products[i]; return null; }
      function countOf(id) { var c = 0; picked.forEach(function (x) { if (x === id) c++; }); return c; }
      function esc(str) { var d = document.createElement('div'); d.textContent = str == null ? '' : String(str); return d.innerHTML.replace(/"/g, '&quot;'); }
      function say(text) { if (msg) msg.textContent = text || ''; }
      function bundleMode() { return purchaseMode() === 'bundle'; }
      function selectBundle() {
        var radio = root.querySelector('[data-mp-purchase][value="bundle"]');
        if (radio && !radio.checked) { radio.checked = true; radio.dispatchEvent(new Event('change', { bubbles: true })); }
      }

      function renderSlots() {
        var n = size();
        slotsEl.innerHTML = '';
        for (var i = 0; i < n; i++) {
          var p = picked[i] != null ? byId(picked[i]) : null;
          if (p) {
            var li = document.createElement('li');
            li.className = 'avalon-mp__slot is-filled';
            li.innerHTML = (p.image ? '<img src="' + esc(p.image) + '" alt="' + esc(p.name) + '">' : '<span>' + esc(p.name) + '</span>') + '<button type="button" class="avalon-mp__slot-x" data-index="' + i + '" aria-label="Remove ' + esc(p.name) + '">' + xSvg + '</button>';
            slotsEl.appendChild(li);
          } else if (slotTpl) {
            slotsEl.appendChild(slotTpl.content.firstElementChild.cloneNode(true));
          }
        }
        if (slotsLabel) slotsLabel.textContent = (slotsLabel.getAttribute('data-template') || '').replace('{filled}', picked.length).replace('{total}', n);
      }
      function renderPicker() {
        var full = picked.length >= size();
        $all(listEl, '[data-id]').forEach(function (li) {
          var id = parseInt(li.getAttribute('data-id'), 10), c = countOf(id);
          li.querySelector('output').textContent = c;
          li.querySelector('[data-act="minus"]').disabled = c === 0;
          li.querySelector('[data-act="plus"]').disabled = full || li.classList.contains('is-soldout');
        });
      }
      function buildPicker() {
        listEl.innerHTML = '';
        products.forEach(function (p) {
          var li = document.createElement('li');
          li.className = 'avalon-mp__pick' + (p.available ? '' : ' is-soldout');
          li.setAttribute('data-id', p.id);
          li.innerHTML = (p.image ? '<img src="' + esc(p.image) + '" alt="">' : '') +
            '<span class="avalon-mp__pick-name">' + esc(p.name) + '<span class="avalon-mp__pick-price">' + esc(money(p.price, cur)) + '</span></span>' +
            '<span class="avalon-mp__step"><button type="button" data-act="minus" aria-label="Remove one ' + esc(p.name) + '">' + minusSvg + '</button><output>0</output><button type="button" data-act="plus"' + (p.available ? '' : ' disabled data-soldout="1"') + ' aria-label="Add one ' + esc(p.name) + '">' + plusSvg + '</button></span>';
          listEl.appendChild(li);
        });
      }
      function renderSummary() {
        if (!summary) return;
        var n = size(), total = 0;
        picked.forEach(function (id) { var p = byId(id); if (p) total += p.price; });
        if (!picked.length) { summary.hidden = true; return; }
        summary.hidden = false;
        var full = picked.length === n, d = pct();
        if (full && d > 0) {
          // Shopify takes the discount per cart line (same product = one line) and drops the fraction of a cent, so do the same
          var counts = {}, off = 0;
          picked.forEach(function (id) { counts[id] = (counts[id] || 0) + 1; });
          Object.keys(counts).forEach(function (id) { var p = byId(parseInt(id, 10)); if (p) off += Math.floor((p.price * counts[id] * d) / 100 + 0.000001); });
          sumOld.hidden = false; sumOld.textContent = money(total, cur);
          sumNew.textContent = money(total - off, cur);
          sumSave.hidden = false;
          sumSave.textContent = (bundleEl.getAttribute('data-label-save') || '').replace('{amount}', money(off, cur)).replace('{percent}', d);
        } else {
          sumOld.hidden = true; sumSave.hidden = true; sumNew.textContent = money(total, cur);
        }
      }
      function renderAll() {
        renderSlots(); renderPicker(); renderSummary();
        if (bundleMode()) update(false);
      }
      function openPicker(open) {
        if (!picker) return;
        picker.classList.toggle('is-open', open);
      }

      tiles.forEach(function (tile) {
        tile.addEventListener('click', function () {
          tiles.forEach(function (x) { x.setAttribute('aria-pressed', x === tile ? 'true' : 'false'); });
          var n = size();
          if (picked.length > n) picked.length = n;
          say('');
          selectBundle();
          renderAll();
        });
      });
      slotsEl.addEventListener('click', function (e) {
        var x = e.target.closest('.avalon-mp__slot-x');
        if (x) {
          var idx = parseInt(x.getAttribute('data-index'), 10);
          if (!isNaN(idx)) picked.splice(idx, 1);
          say(''); renderAll();
          return;
        }
        if (e.target.closest('[data-mp-open]')) { selectBundle(); openPicker(true); }
      });
      listEl.addEventListener('click', function (e) {
        var btn = e.target.closest('button[data-act]');
        if (!btn || btn.disabled) return;
        var li = btn.closest('[data-id]'), id = parseInt(li.getAttribute('data-id'), 10);
        if (btn.getAttribute('data-act') === 'plus') {
          if (picked.length < size()) picked.push(id);
        } else {
          var at = picked.lastIndexOf(id);
          if (at > -1) picked.splice(at, 1);
        }
        say(''); selectBundle(); renderAll();
        if (picked.length >= size()) openPicker(false);
      });

      bundleApi = {
        syncButton: function () {
          if (!atc) return;
          var left = size() - picked.length;
          if (sending) { atc.disabled = true; return; }
          if (left > 0) {
            atc.disabled = true;
            atc.textContent = (bundleEl.getAttribute('data-label-more') || 'Choose {remaining} more').replace('{remaining}', left);
          } else {
            atc.disabled = false;
            atc.textContent = bundleEl.getAttribute('data-label-done') || 'Add bundle to cart';
          }
        },
        submit: function () {
          if (sending) return;
          var n = size();
          if (picked.length !== n) { say((bundleEl.getAttribute('data-label-more') || '').replace('{remaining}', n - picked.length)); openPicker(true); return; }
          var groups = {}, order = [];
          picked.forEach(function (id) { var p = byId(id); if (!p) return; if (!groups[p.variant]) { groups[p.variant] = 0; order.push(p.variant); } groups[p.variant]++; });
          var props = {}; props[bundleEl.getAttribute('data-prop') || 'Bundle'] = n + ' ' + ((activeTile() && activeTile().querySelector('span') ? activeTile().querySelector('span').textContent.replace(/^[0-9]+\s*/, '') : 'pack'));
          var items = order.map(function (v) { return { id: v, quantity: groups[v], properties: props }; });
          var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
          sending = true; bundleApi.syncButton(); say('');
          fetch(base + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
            .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw new Error(d && (d.description || d.message) || 'Could not add to cart'); return d; }); })
            .then(function () { window.location.href = base + 'cart'; })
            .catch(function (err) { sending = false; say(err && err.message ? err.message : 'Could not add to cart'); update(false); });
        }
      };

      buildPicker();
      renderAll();
    })();

    var minus = root.querySelector('[data-mp-minus]'), plus = root.querySelector('[data-mp-plus]');
    if (qty && minus) minus.addEventListener('click', function () { qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) - 1); });
    if (qty && plus) plus.addEventListener('click', function () { qty.value = (parseInt(qty.value, 10) || 1) + 1; });
    if (qty) qty.addEventListener('change', function () { qty.value = Math.max(1, parseInt(qty.value, 10) || 1); });

    $all(root, '[data-mp-thumb]').forEach(function (t) { t.addEventListener('pointerenter', function () { var m = t.getAttribute('data-media-id'); $all(root, '[data-mp-slide]').forEach(function (s) { if (String(s.getAttribute('data-media-id')) === String(m)) loadSlide(s); }); }); t.addEventListener('click', function () { activateSlide(t.getAttribute('data-media-id')); }); });
    var prev = root.querySelector('[data-mp-prev]'), next = root.querySelector('[data-mp-next]');
    if (prev) prev.addEventListener('click', function () { stepSlide(-1); });
    if (next) next.addEventListener('click', function () { stepSlide(1); });

    var form = root.querySelector('form');
    if (form && atc) form.addEventListener('submit', function (e) {
      if (purchaseMode() === 'bundle') { e.preventDefault(); if (bundleApi) bundleApi.submit(); return; }
      if (!idInput || !idInput.value) { e.preventDefault(); return; }
      atc.disabled = true; // no double clicks; the page goes to the cart
      setTimeout(function () { atc.disabled = false; }, 4000);
    });

    update(false);
    moveRing(false);
    // The photos stick below the navigation bar: its height is added while it is showing, dropped while it is hidden
    var hdr = document.getElementById('SiteHeader');
    var gap = parseFloat(root.getAttribute('data-sticky-gap')) || 0;
    function setTop() {
      var h = 0;
      if (hdr && !hdr.classList.contains('avalon-header--hidden')) h = hdr.getBoundingClientRect().height;
      root.style.setProperty('--mp-top', Math.round(h + gap) + 'px');
      // the photo is sized for the header showing, so it does not resize each time the bar hides or returns
      if (h && !root.style.getPropertyValue('--mp-reserve')) root.style.setProperty('--mp-reserve', Math.round(h + gap) + 'px');
    }
    if (hdr) {
      setTop();
      new MutationObserver(setTop).observe(hdr, { attributes: true, attributeFilter: ['class'] });
      if (window.ResizeObserver) new ResizeObserver(setTop).observe(hdr);
    }
    window.addEventListener('resize', function () { root.style.removeProperty('--mp-reserve'); setTop(); moveRing(false); });
    window.addEventListener('load', function () { moveRing(false); });
    if (window.ResizeObserver) { var st = root.querySelector('.avalon-mp__thumbs'); if (st) new ResizeObserver(function () { moveRing(false); }).observe(st); }
  }

  function scan(scope) { $all(scope || document, '[data-section-type="avalon-main-product"]').forEach(init); }
  scan(document);
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();
